<script lang="ts" setup>
withDefaults(
  defineProps<{
    color?: string
    size?: string
  }>(),
  {
    color: 'gray',
    size: 'xs',
  },
)

// prettier-ignore
const colors = {
  'red': 'bg-red-100 text-red-900 ring-red-700/20',
  'orange': 'bg-orange-100 text-orange-700 ring-orange-200/75',
  'amber': 'bg-amber-100 text-amber-900 ring-amber-200/75',
  'green': 'bg-green-100 text-green-700 ring-green-200/75',
  'emerald': 'bg-emerald-100 text-emerald-700 ring-emerald-200/75',
  'sky': 'bg-sky-100 text-sky-700 ring-sky-200/75',
  'gray': 'bg-gray-100 text-gray-600 ring-gray-200/90',
  'v-blue': 'bg-[#3982AF]/10 text-[#3982AF] ring-[#3982AF]/20',
  'v-green': 'bg-[#408F92]/10 text-[#408F92] ring-[#408F92]/20',
}

// prettier-ignore
const sizes = {
  'xxs': 'px-1.5 py-0.5 text-xs rounded',
  'xs': 'px-2 py-1 text-xs rounded-md',
}
</script>

<template>
  <span class="inline-block whitespace-normal font-medium ring-1" :class="[colors[color], sizes[size]]">
    <slot></slot>
  </span>
</template>
